import { render, staticRenderFns } from "./BulkPayments.vue?vue&type=template&id=47501eb4&"
import script from "./BulkPayments.vue?vue&type=script&lang=js&"
export * from "./BulkPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports